/**
 * @generated SignedSource<<be9d76f63db93553bbb649b37a6b4c41>>
 * @relayHash 91adf951953bfe64ddb250042a4a0511
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1833329048b99734ed78f2acc837e88e917ff4ae53ed33b16de39b8b3f5a0527

import type { ConcreteRequest, Query } from 'relay-runtime';
export type teamPreviewPanelQuery$variables = {
  cloudId: string;
};
export type teamPreviewPanelQuery$data = {
  readonly me: {
    readonly user: {
      readonly id: string;
    } | null | undefined;
  };
  readonly tenantContexts: ReadonlyArray<{
    readonly orgId: string | null | undefined;
  } | null | undefined> | null | undefined;
};
export type teamPreviewPanelQuery = {
  response: teamPreviewPanelQuery$data;
  variables: teamPreviewPanelQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = {
  "args": [
    {
      "items": [
        {
          "kind": "Variable",
          "name": "cloudIds.0",
          "variableName": "cloudId"
        }
      ],
      "kind": "ListValue",
      "name": "cloudIds"
    }
  ],
  "concreteType": "TenantContext",
  "kind": "LinkedField",
  "name": "tenantContexts",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "orgId"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "teamPreviewPanelQuery",
    "selections": [
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v1/*: any*/)
            ]
          }
        ]
      },
      (v2/*: any*/)
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "teamPreviewPanelQuery",
    "selections": [
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              (v1/*: any*/)
            ]
          }
        ]
      },
      (v2/*: any*/)
    ]
  },
  "params": {
    "id": "1833329048b99734ed78f2acc837e88e917ff4ae53ed33b16de39b8b3f5a0527",
    "metadata": {},
    "name": "teamPreviewPanelQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "6b8a5c1e76dd69e5d8daea6919628199";

export default node;
